import { render, staticRenderFns } from "./dash-menu.vue?vue&type=template&id=dc9c0930&scoped=true"
import script from "./dash-menu.vue?vue&type=script&lang=js"
export * from "./dash-menu.vue?vue&type=script&lang=js"
import style0 from "./dash-menu.vue?vue&type=style&index=0&id=dc9c0930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9c0930",
  null
  
)

export default component.exports